import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import { LOGIN_DRAWER } from '@constants/toggleables';
import segmentStorage from '@events/segmentStorage';
import { useToggleable } from '@stores/toggleables';
import { useEffect, useRef } from 'react';

const dowlaodBrochure = (brochure) => {
  window.open(brochure, '_blank');
};

const useBrochureDownload = () => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const downloadButtonClicked = useRef(null);
  const { openElement: openLoginDrawer, isOpen: isLoginDrawerOpen } =
    useToggleable(LOGIN_DRAWER);

  useEffect(() => {
    if (isLoggedIn && downloadButtonClicked.current) {
      dowlaodBrochure(downloadButtonClicked.current);
      downloadButtonClicked.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isLoginDrawerOpen) {
      downloadButtonClicked.current = null;
    }
  }, [isLoginDrawerOpen]);

  const handleDownload = (brochure) => {
    if (!isLoggedIn) {
      segmentStorage.setItem('lpss', 'Batch brochure download');
      downloadButtonClicked.current = brochure;
      openLoginDrawer();
    } else dowlaodBrochure(brochure);
  };

  return { handleDownload };
};

export default useBrochureDownload;
